import React from 'react'
import { Row, Column, GridContainer, H1, SWAN_STYLE_KEY_MAP } from '@vp/swan'
import { OrderTrackingLink } from './components/OrderTrackingLink'
import { useTranslation } from 'react-i18next'
import styles, { stylesheet } from './App.scss'
import { useLogger, useStyles, useSwanStyleKeys } from '@vp/ubik-context'
import { HelpCenterUrls } from './types/urls.type'
import { formatLocale } from './utils/general.utils'
import { HelpCenterSearch } from '@vp/help-center-articles-search'

export interface AppProps {
  locale: string
  tenant: string
  helpCenterUrls: HelpCenterUrls
}
export const App = (props: AppProps) => {
  const { locale, tenant, helpCenterUrls } = props
  const lng = locale.toLowerCase().replace('-', '_')
  const logger = useLogger()

  const { t } = useTranslation(tenant)
  useStyles(stylesheet)
  useSwanStyleKeys([SWAN_STYLE_KEY_MAP.core, SWAN_STYLE_KEY_MAP.popover, SWAN_STYLE_KEY_MAP.hidden, SWAN_STYLE_KEY_MAP.listbox])

  return (
    <GridContainer>
      <Row className={styles.hcSearchHeaderContainer}>
        <Column span={12} spanXs={12}>
          <Row>
            <Column span={12} marginBottom="6" textAlign="center">
              <H1 fontSkin="title-headline">{t(`${tenant}:header.search.title`, { lng })}</H1>
            </Column>
          </Row>
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          <Row align="center" style={{ display: 'flex', justifyContent: 'center' }} paddingX={5}>
            <Column span={6} spanXs={12} spanSm={8} pr={0}>
              <div style={{ maxWidth: '490px', textAlign: 'left' }}>
                <HelpCenterSearch
                  variation="header"
                  logger={logger}
                  resultsPageUrl={helpCenterUrls.newPlatformSearchUrl}
                  locale={formatLocale(locale)}
                  applicationName="help-center-page"
                  comboboxOverrides={{ style: { width: '100%' } }}
                  environment="prod"
                />
              </div>
            </Column>
          </Row>
          <Row pt={6}>
            <Column span={12} spanXs={12} spanSm={12} spanMd={12} textAlign="center">
              <OrderTrackingLink tenant={tenant} locale={locale} />
            </Column>
          </Row>
        </Column>
      </Row>
    </GridContainer>
  )
}
